import React from 'react';
import Banner from '../components/banner/Banner';
import CardSection from '../components/cards/CardSection';
import ZigZagCards from '../components/zig-zag-cards/ZigZagCards';
import Slider from '../components/slider/Slider';
import OrgChart from '../components/org-chart/OrgChart';

interface IOrgChart {
  name: string;
  designation: string;
  image: string;
}


const HomePage = () => {

  const slides = [
    {
      image: '/slider/slider.jpg',
      heading: 'Heading 1',
      description: 'Description 1: Lorem ipsum dolor sit amet...',
    },
    {
      image: '/slider/slider.jpg',
      heading: 'Heading 2',
      description: 'Description 2: Ut enim ad minim veniam...',
    },
    {
      image: '/slider/slider.jpg',
      heading: 'Heading 3',
      description: 'Description 3: Duis aute irure dolor in...',
    },
  ];

  const cardsData = [
    {
      image: '/arco-pertroleum-gas-station.jpg',
      title: 'Gas Station & Convenience Store Portoflio',
      url: '/petroleum-portfolio'
      // description: "Global Management Inc. is a key player in the petroleum industry, providing comprehensive solutions across the entire value chain. From exploration and production to refining and distribution, we leverage our expertise and strategic partnerships to ensure the efficient and responsible delivery of energy resources. Our commitment to sustainability drives us to explore and invest in renewable energy sources, paving the way for a cleaner and more sustainable future.",
    },
    {
      image: '/hotels.png',
      title: 'Hospitality Portfolio',
      url: '/hospitality-services',
      // description: "Experience world-class hospitality with Global Management Inc.'s hotel management services. We curate exceptional guest experiences by overseeing daily operations, optimizing revenue strategies, and implementing innovative marketing initiatives. Our commitment to excellence ensures that each hotel under our management delivers unparalleled service, luxurious accommodations, and unforgettable memories for every guest.",
    },
    {
      image: '/real-estate-card.jpg',
      title: 'Real Estate And Development',
      url: '/real-estate-development'
      // description: 'Global Management Inc. excels in real estate development and management, transforming landscapes and building thriving communities. We identify prime locations, acquire land, and oversee the entire development process, from concept to completion. Our expertise encompasses residential, commercial, and mixed-use projects, delivering exceptional properties that meet the diverse needs of our clients and investors.',
    }
  ];

  const zigzagCardsData = [
    {
      title: 'Fueling Growth',
      description: "At Global Management Inc., we're more than just energy consultants; we're your strategic partners in navigating the complex world of petroleum. Our team brings decades of combined experience across the upstream, midstream, and downstream sectors. This means we can assist with everything from exploration and production optimization to refining efficiency and even the intricacies of marketing and distribution in today's evolving energy markets. We leverage cutting-edge technology and data analysis to provide insights that drive smarter decision-making. Whether it's identifying new resource opportunities, streamlining logistics, or ensuring regulatory compliance, we empower our clients to maximize their petroleum assets' value. In an era of increasing environmental awareness, we also prioritize sustainable practices, helping companies minimize their ecological footprint while achieving ambitious growth targets.",
      image: '/petroleum.png',
    },
    {
      title: 'Building the Future, Today',
      description: 'At Global Management Inc., our Real Estate and Development division is driven by a vision to create spaces that inspire, connect, and endure. We are committed to developing innovative and sustainable projects that enhance communities and deliver exceptional value.',
      image: '/real-estate-development.jpg',
    },
    {
      title: 'Experience the Global Management Inc. Difference',
      description: "At Global Management Inc., we believe in creating exceptional experiences. Our hotel division is dedicated to providing world-class hospitality that exceeds expectations. We curate a diverse portfolio of hotels, each offering a unique blend of comfort, style, and personalized service. Whether you're traveling for business or leisure, our hotels provide a haven of comfort and style. We invite you to experience the Global Management Inc. difference and discover a new standard of hospitality..",
      image: '/hotels.png',
    }
  ];

  const orgChartData:any = [
    {
      name: "Nayan Patel",
      designation: "President Finance",
      image: "/org-chart/nayan-patel.jpeg"
    },
    {
      name: "Arun Patel",
      designation: "Secretary Acquisition and Investment",
      image: "/org-chart/arun-patel.jpeg"
    },
    {
      name: "Roshan Patel",
      designation: "VP Operations Hospitality",
      image: "/org-chart/roshan-patel.jpeg"
    },
    {
      name: "Sunil Patel",
      designation: "VP Operations Petro and Retail",
      image: "/org-chart/sunil-patel.jpeg"
    },
    {
      name: "Parth Patel",
      designation: "Treasurer Sales and Marketing",
      image: "/org-chart/parth-patel.jpeg"
    },
    
  ]

  return (
    <>
      <Banner />
      <CardSection
        title="Our Services"
        description="Explore our range of services designed to meet your needs."
        cards={cardsData}
      />

      <OrgChart cards={orgChartData} />

      {/* <ZigZagCards cards={zigzagCardsData} /> */}

    </>
  );

};

export default HomePage;